import Image from 'next/image';
import type { ReactElement } from 'react';

import Title from '@/components/atoms/Title';
import { SectionWrap } from '@/components/store/components/SectionWrap/SectionWrap';

import {
  BenefitItem,
  BenefitTitle,
  Description,
  Grid,
  IconWrapper,
  Wrapper,
} from './BenefitsGrid.styled';

interface Benefit {
  description: string;
  icon: string;
  title: string;
}

const benefits: Benefit[] = [
  {
    icon: '/static/images/teneryfa/benefit-1.svg',
    title: 'Miejsca must see',
    description:
      'Sprawdź, co warto zobaczyć i nie trać czasu na przereklamowane atrakcje. Skorzystaj z gotowych planów podróży, by w pełni cieszyć się tym, co oferuje wyspa.',
  },
  {
    icon: '/static/images/teneryfa/benefit-2.svg',
    title: 'Najpiękniejsze plaże',
    description:
      'Znajdź idealne miejsce na surfing, nurkowanie lub bezpieczną kąpiel z dzieckiem. Dowiedz się, gdzie trafisz na piaszczystą plażę, a gdzie przydadzą się buty wodne.',
  },
  {
    icon: '/static/images/teneryfa/benefit-3.svg',
    title: 'Najlepsze restauracje',
    description:
      'Nie trać czasu i pieniędzy na niesprawdzone restauracje i niesmaczne jedzenie. Szukasz wegetariańskich opcji? Również znajdziesz tu coś dla siebie.',
  },
  {
    icon: '/static/images/teneryfa/benefit-4.svg',
    title: 'Ukryte miejsca',
    description:
      'Wejdź na wulkan nocą, odkryj ruiny na skalistym zboczu, czerwoną jaskinię i kury na plantacji bananów. Zbocz z popularnych tras i poznaj Teneryfę z innej strony.',
  },
  {
    icon: '/static/images/teneryfa/benefit-5.svg',
    title: 'Najciekawsze szlaki',
    description:
      'Marzy Ci się aktywny wypoczynek? Zamiast szukać godzinami tras, skorzystaj z przykładowych szlaków i gotowych map na trekking.',
  },
  {
    icon: '/static/images/teneryfa/benefit-6.svg',
    title: 'Pomoc w organizacji',
    description:
      'Zorganizuj ze mną swoją podróż - kup tanie loty, dowiedz się gdzie spać, jak dojechać, zaplanuj budżet i aktywności w najbardziej optymalny sposób.',
  },
  {
    icon: '/static/images/teneryfa/benefit-7.svg',
    title: 'Wskazówki transportowe',
    description:
      'Wynajmij bezpiecznie auto i uniknij ukrytych kosztów. Dowiedz się jak poruszać się komunikacją miejską lub zaplanuj wycieczkę na inną kanaryjską wyspę.',
  },
  {
    icon: '/static/images/teneryfa/benefit-8.svg',
    title: 'Sposoby na oszczędność',
    description:
      'Zobacz jakich cen spodziewać się na wyspie, gdzie tanio zjeść, jak oszczędzić na transporcie i co wziąć ze sobą, by nie płacić za lekarza w razie wypadku.',
  },
];

export const BenefitsGrid = (): ReactElement => (
  <SectionWrap>
    <Wrapper>
      <Title>Co dostaniesz?</Title>
      <Grid>
        {benefits.map(benefit => (
          <BenefitItem key={benefit.title}>
            <IconWrapper>
              <Image src={benefit.icon} alt={benefit.title} fill />
            </IconWrapper>
            <BenefitTitle>{benefit.title}</BenefitTitle>
            <Description>{benefit.description}</Description>
          </BenefitItem>
        ))}
      </Grid>
    </Wrapper>
  </SectionWrap>
);
